import React from 'react';
import { Message, toaster } from 'rsuite';

function showSuccessMessage(message: string) {
  toaster.push(
    <Message
      type="success"
      closable
      showIcon
    >
      {message}
    </Message>,
    { duration: 2000 },
  );
}

function showErrorMessage(message: string) {
  toaster.push(
    <Message
      type="error"
      header="Error"
      closable
      showIcon
    >
      {message}
    </Message>,
    { duration: 0 },
  );
}

export { showSuccessMessage, showErrorMessage };
